
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prijslijst",
      function () {
        return require("private-next-pages/prijslijst.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prijslijst"])
      });
    }
  